import * as React from "react";
const LbtcIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path opacity="0.3" d="M11 6H0V17H11V6Z" fill="black" />
    <path
      opacity="0.4"
      d="M14.849 3H0V6H11V17H0V20H14.849V18.152L16.141 16.9439L17 15.4458V7.68803L16.141 6.26415L14.8726 5.34402L14.849 3Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6776 4.42659C16.9547 4.6399 18.7576 5.38675 18.9577 7.612L18.9587 7.61133C19.1078 9.24004 18.4683 10.2155 17.4456 10.7724C19.1287 11.2057 20.1827 12.2706 19.9737 14.659C19.7159 17.6244 17.6396 18.4193 14.6745 18.5992V20H12.9109V18.6409C12.4539 18.6416 11.9854 18.6371 11.5022 18.6259V19.9996H9.74028V18.5926C9.32823 18.5898 7.42717 18.5809 7 18.5809L7.01302 16.9483H8.48386V6.0953L7.01246 6.08646L7.01777 4.43049C7.01777 4.43049 9.3628 4.43261 9.74438 4.42489V3H11.5065V4.36426C11.9777 4.35475 12.4512 4.34532 12.9146 4.34532V3.00108H14.6776V4.42659ZM11.8858 16.3572C13.3304 16.3791 16.4872 16.4273 16.4872 14.2863H16.4856C16.4851 12.0964 13.4485 12.1725 11.9697 12.2095C11.8058 12.2136 11.6609 12.2172 11.5416 12.2172V16.3533C11.6401 16.3533 11.7559 16.3551 11.8858 16.3572ZM11.8353 10.3277C13.0413 10.349 15.6689 10.3957 15.6689 8.45022C15.6699 6.46061 13.1439 6.5305 11.9078 6.56497C11.7684 6.5688 11.6452 6.57202 11.5442 6.57202V10.324C11.6273 10.324 11.7254 10.3258 11.8353 10.3277Z"
      fill="black"
    />
  </svg>
);
export default LbtcIcon;
